import React, { useEffect, useState } from 'react'
import { CircularProgressbar,buildStyles  } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { useNavigate } from 'react-router-dom';
import Translate from '../../../Components/MultiLanguage/Translate';

const waitingTime = 10;
let timerSeconds = waitingTime;
const Autoplay = ({episodes, setIsAutoplayView, isPlaylist = false, onVideoChange, currentVideoId, showId, prevPath}) => {
    const [timer, setTimer] = useState(waitingTime)
    const navigate = useNavigate()

    useEffect(() => {
        if (isPlaylist && episodes) {
            playNextEpisodeHandler();
            return;
        }
        const interval = setInterval(() => {
                timerSeconds--
                if(timerSeconds>=0){
                    setTimer((prev)=>prev-1)
                }else{
                    clearInterval(interval)
                }
           
        }, 1000);

        return ()=>{
            clearInterval(interval)
            resetValues()
        }
    },[])

    useEffect(()=>{
        if(timer===0){
            playNextEpisodeHandler()
        }
    },[timer])

    const playNextEpisodeHandler = () =>{
        setIsAutoplayView(false)
        setTimer(waitingTime)
        timerSeconds = waitingTime
        
        if (isPlaylist && episodes) {
            const currentIndex = episodes.findIndex(
                (episode) => episode.video_id === currentVideoId
            );

            const nextIndex = currentIndex + 1;
            if (nextIndex < episodes.length) {
                onVideoChange(episodes[nextIndex]);
            }
        } else if (episodes && episodes.length > 0) {
            const nextVideo = episodes[0];
            const nextShowId = showId || nextVideo?.show_id;
            const nextVideoUrl = nextShowId
                ? `/videos/${nextVideo?.vanity_url}?showId=${nextShowId}`
                : `/videos/${nextVideo?.vanity_url}`;

            navigate(nextVideoUrl, {
                state: {
                    videoDetails: { video_id: nextVideo?.video_id },
                    showId: nextShowId,
                    showDetails: { show_id: nextShowId },
                    prevPath
                }
            })
        }
    }

    const resetValues = () => {
        setTimer(waitingTime)
        timerSeconds = waitingTime
    }

  return (
    <div className='autoplayComponent'>
        <div className="content">
            <div className="progressBar">
            <CircularProgressbar 
                value={Math.round((10-timer)*10)} 
                text={`${timer}s`}
                styles={buildStyles({
                    pathColor: `var(--button-color)`,
                    textColor:  `var(--button-color)`,
                })} 
            />
            </div>
            <span className="timer"><Translate textKey={'next_video'}/> {timer}s</span>
        </div>
    </div>
  )
}

export default Autoplay